import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Checkbox, { CheckboxGroup } from '../../../../../ui-kitchen/src/components/Checkbox';

const Multiselect = ({
  options,
  questionsetId,
  questionId,
  answerQuestion,
}) => {
  const defaultOpt = options.map((option) => (options ? option.text : null)).reduce((acc, optionKey) => {
    acc[optionKey] = false;
    return acc;
  }, {});
  const [selection, setSelection] = useState(defaultOpt);
  const handleSelection = (optionId, isSelected) => {
    const updatedSelection = { ...selection, [optionId]: isSelected };
    setSelection(updatedSelection);
    answerQuestion(
      questionsetId,
      questionId,
      Object.keys(updatedSelection).filter((key) => updatedSelection[key] === true).map(Number),
      null
    );
  };

  return (
    <div data-test-id="multiselect">
      {options.map((option) => (
        <CheckboxGroup
          key={`${questionsetId} ${option.id}`}
        >
          <Checkbox
            role="checkbox"
            checked={selection[option.text]}
            onChange={(value) => handleSelection(option.id, value[option.text])}
            name={option.text}
          />
          <label htmlFor={option.text}>{option.text}</label>
        </CheckboxGroup>
      ))}
    </div>
  );
};

Multiselect.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      value: PropTypes.number,
      order: PropTypes.number,
    })
  ),
  questionsetId: PropTypes.number,
  questionId: PropTypes.number,
  answerQuestion: PropTypes.func,
};

Multiselect.defaultProps = {
  options: [],
  questionId: null,
  questionsetId: null,
  answerQuestion: () => { },
};

export default Multiselect;
